import { environment } from './../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Persona } from '../clases/persona';

@Injectable({
  providedIn: 'root'
})
export class PersonaService {

  constructor(private readonly http: HttpClient) { }

  public agregarPersona(persona: Persona): Observable<any>{
    return this.http.post(environment.backEndHost + environment.serverEndPoint + "/personas/", persona);
  } 
  
  public editarPersona(persona: Persona): Observable<any>{
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/personas/"+persona.id, persona);
  } 

  public deletePersona(persona: Persona): Observable<any>{
    return this.http.delete(environment.backEndHost + environment.serverEndPoint + "/personas/" + persona.id);
  }

  public getProfileAvatar(): Observable<any> {
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/personas/profile-avatar");
  }

  public updateProfileAvatar(payload: { foto: string; fotoContentType: string }): Observable<any> {
    return this.http.put(environment.backEndHost + environment.serverEndPoint + "/personas/profile-avatar", payload);
  }

  public getPersonaById(id: number): Observable<any> {
    return this.http.get(environment.backEndHost + environment.serverEndPoint + "/personas/" + id);
  }

  public patchPersonaAvatar(id: number, payload: { foto: string; fotoContentType: string }): Observable<any> {
    return this.http.patch(environment.backEndHost + environment.serverEndPoint + "/personas/" + id, payload);
  }


}
